import { render, staticRenderFns } from "./WebhooksDetail.vue?vue&type=template&id=25f747fb"
import script from "./WebhooksDetail.vue?vue&type=script&lang=js"
export * from "./WebhooksDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports